import * as PropTypes from 'prop-types';
import { SemanticSTATICTRANSITIONS } from 'semantic-ui-react';
import { StateHandlerMap, StateHandler } from 'recompose';
import { State } from './state';
import { TransitionEventData } from 'semantic-ui-react/dist/commonjs/modules/Transition/Transition';

export interface Props {
  animation: SemanticSTATICTRANSITIONS;
  children?: object;
  duration: number;
  await: boolean;
  onClick?: () => void;
}

export const propTypes = {
  animation: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  duration: PropTypes.number.isRequired,
  await: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

export type StateHandlerProps = StateHandlerMap<State> & {
  onComplete(): StateHandler<State>;
  onClickHandler(): StateHandler<State>;
  setTimer(timer?: NodeJS.Timer): StateHandler<State>;
};

export type HandlerProps = {
  handleOnClick: Function;
  handleOnComplete: (nothing: null, data: TransitionEventData) => void;
};

export type EnhancedProps =
  Props &
  HandlerProps &
  State &
  StateHandlerProps;


// WEBPACK FOOTER //
// ./src/components/retransition/props.ts